// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603120747/js/" + chunkId + "." + {"44":"038a2ae8","225":"6b0c1369","481":"25cc8474","486":"5d33b4e6","770":"2a30343e"}[chunkId] + ".0.3834557193992427.chunk.js";
};